import React from 'react';
import { Heading } from '../../../components';
import { images } from '../../../constants'; // Zostawiamy tylko import obrazków
import { FaLeaf, FaFeatherAlt } from 'react-icons/fa';
import './TreeTasks.css';
import { useTranslation } from 'react-i18next';

const TreeTasks = () => {
    const { t } = useTranslation();

    // Pobieramy całe tablice bezpośrednio z JSON, używając returnObjects: true
    const sampleTasks = t('treesampleTasks', { returnObjects: true }) || [];
    const manifest = t('manifestTree', { returnObjects: true }) || [];

    return (
        <div className='tree-tasks-container'>

            {/* =========================================
                CZĘŚĆ 1: DZIAŁANIE (Lista / Notatnik)
               ========================================= */}
            <section className='actions-section-bg'>
                <div className='tasks-wrapper'>
                    <Heading 
                        title={t('treeTasks.actionHeading')} 
                        subTitle={t('treeTasks.actionSubTitle')} 
                    />
                    
                    <p className='tasks-intro'>
                        {t('treeTasks.actionIntro')}
                    </p>

                    <div className='actions-list'>
                        {/* Mapujemy bezpośrednio po pobranej liście */}
                        {sampleTasks.map((task, index) => (
                            <div className='action-row' key={`task-${index}`}>
                                <div className='task-icon-wrapper'>
                                    <FaLeaf className='task-icon' />
                                </div>
                                <span className='task-text'>{task}</span>
                            </div>
                        ))}
                    </div>

                    <p className='tasks-outro'>
                        {t('treeTasks.actionOutro')}
                    </p>
                </div>
            </section>

            {/* =========================================
                CZĘŚĆ 2: MANIFEST (Ciemne tło, zdjęcie)
               ========================================= */}
            <section className='manifest-section-bg'>
                <div className='manifest-container'>
                    {/* LEWA KOLUMNA - ZDJĘCIE */}
                    <div className='manifest-image-wrapper'>
                        <img src={images.tree3} alt="Stare drzewo" className="manifest-img" />
                    </div>

                    {/* PRAWA KOLUMNA - TEKST */}
                    <div className='manifest-content-wrapper'>
                        <Heading 
                            title={t('treeTasks.manifestHeading')} 
                            subTitle={t('treeTasks.manifestSubTitle')} 
                            light={true} 
                            sideHeading={true} 
                        />
                        
                        <p className='manifest-intro-text'>
                            {t('treeTasks.manifestIntro')}
                        </p>

                        <ul className='manifest-list'>
                            {/* Mapujemy bezpośrednio po pobranym manifeście */}
                            {manifest.map((item, index) => (
                                <li key={`manifest-list-${index}`}>
                                    <FaFeatherAlt className="manifest-list-icon" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default TreeTasks;